export default __webpack_public_path__ + "graphics/swimming-pool--blurred.43c892d8.jpg";